export default "__VITE_ASSET__DwhRpRDX__"